import { Component, HostListener, OnInit } from '@angular/core';
import { Router, Event as RouterEvent, NavigationStart, RouterOutlet } from '@angular/router';
import { Shared } from '../shared/shared';
import { SessionService } from '../session/session.service';


@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

  constructor(private router: Router, public shared: Shared, 
    private sessionService: SessionService) {
    this.shared.isLoading.subscribe((r) => { this.shared.loading = r; });
    this.router.events.subscribe((event: RouterEvent) =>
    {
      if (event instanceof NavigationStart)
      {
        this.sessionService.isAuthenticated().subscribe({
          next: (response) => {
            if (!response.completed) {
              this.shared.complete = false;
              window.location.href = '/ShowLogin';
            } else {

              this.shared.userInfo = response.data;
              if (this.shared.userInfo.defaultLanguageEs) {
                this.shared.language = 'es';
              }
              if (!this.shared.complete) {
                this.shared.complete = true;
                this.router.navigate(['main/home']);
              }
            }
          },
          error: (error) => {
            console.error(error);
            window.location.href = '/ShowLogin';
          }
        });
      }
    });
  }

  ngOnInit(): void { }
}
